module.exports = __webpack_public_path__ + "img/DW365-027.503af172.jpg";